module.exports = __webpack_public_path__ + "img/new9.57d36fb0.jpg";